"use client";

import type { ToastItem, ToastType } from "./types";
import styles from "./index.module.less";

export interface ToastProps {
  items: ToastItem[];
}

function ToastIconSuccess() {
  return (
    <svg
      className={styles.iconSvg}
      viewBox="0 0 20 20"
      width={20}
      height={20}
      aria-hidden
    >
      <circle
        cx="10"
        cy="10"
        r="9"
        fill="none"
        className={styles.iconStrokeSuccess}
        strokeWidth="1.5"
      />
      <path
        d="M6 10l2.5 2.5L14 7"
        fill="none"
        className={styles.iconStrokeSuccess}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ToastIconError() {
  return (
    <svg
      className={styles.iconSvg}
      viewBox="0 0 20 20"
      width={20}
      height={20}
      aria-hidden
    >
      <circle
        cx="10"
        cy="10"
        r="9"
        fill="none"
        className={styles.iconStrokeError}
        strokeWidth="1.5"
      />
      <path
        d="M7 7l6 6M13 7l-6 6"
        fill="none"
        className={styles.iconStrokeError}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

function ToastIconInfo() {
  return (
    <svg
      className={styles.iconSvg}
      viewBox="0 0 20 20"
      width={20}
      height={20}
      aria-hidden
    >
      <circle
        cx="10"
        cy="10"
        r="9"
        fill="none"
        className={styles.iconStrokeInfo}
        strokeWidth="1.5"
      />
      <path
        d="M10 9v5M10 6.5h.01"
        fill="none"
        className={styles.iconStrokeInfo}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function Toast({ items }: ToastProps) {
  if (items.length === 0) return null;

  function renderForType(type: ToastType) {
    switch (type) {
      case "success":
        return <ToastIconSuccess />;
      case "error":
        return <ToastIconError />;
      case "info":
        return <ToastIconInfo />;
      default:
        return null;
    }
  }

  return (
    <div
      className={styles.viewport}
      role="region"
      aria-label="Notifications"
      aria-live="polite"
    >
      {items.map((item) => (
        <div key={item.id} className={styles.row} role="status">
          <div className={styles.inner}>
            <span className={styles.icon}>{renderForType(item.type)}</span>
            <span className={styles.message}>{item.message}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
